<template>
  <div class="parentBox" :class="{ 'selectedBox': selected }">
    <p class="topParentText">{{ data.label }}</p>
    <NodeResizer min-width="100" min-height="30" />
  </div>
</template>

<script>
// import { Handle } from "@vue-flow/core";
// import BaseButton from "../buttons/BaseButton.vue";
import { ScanBarcode, ListPlus } from "lucide-vue-next";
import { NodeResizer } from "@vue-flow/node-resizer";

export default {
  name: "BaseNode",
  props: {
    selected: Boolean,
    data: Object,
    id: String,
    // title: String,
    // text: String,
  },
  components: {
    // Handle,
    // BaseButton,
    NodeResizer,
  },
  methods: {
    toggleOptions() {
      this.toggledOptions = !this.toggledOptions;
    },
    async suggestTool() {
      this.$emit("updateNodeTool", this.id, this.data);
    },
  },
  data() {
    return {
      toggledOptions: false,
      ScanBarcode,
      ListPlus,
      // PenTool,
    };
  },
};
</script>

<style scoped>
.parentBox {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  background-color: #721cff10;
  border: thin solid #721cff40;
  border-radius: 8px;
  padding: 10px;
}
.topParentText {
  /* position: absolute; */
  background: #721cff;
  color: white;
  padding: 5px;
  border-radius: 5px;
  font-size: 14px;
  /* transform: translate(-10px, -40px); */
}
</style>
